import moment from "moment";
/**
 * 时间日期相关操作
 */
/**
 * 时间格式化
 * 将 2018-09-23T11:54:16.000+0000 格式化成 2018/09/23 11:54:16
 * @param datetime 国际化日期格式
 */
export function format(datetime) {
  return formatWithSeperator(datetime, "/", ":");
}

/**
 * 时间格式化
 * 将 2018-09-23T11:54:16.000+0000 格式化成类似 2018/09/23 11:54:16
 * 可以指定日期和时间分隔符
 * @param datetime 国际化日期格式
 */
export function formatWithSeperator(datetime, dateSeprator, timeSeprator) {
  if (datetime != null) {
    const dateMat = new Date(datetime);
    const year = dateMat.getFullYear();
    const month = dateMat.getMonth() + 1;
    const day = dateMat.getDate();
    const hh = dateMat.getHours();
    const mm = dateMat.getMinutes();
    const ss = dateMat.getSeconds();
    const timeFormat = year + dateSeprator + month + dateSeprator + day + " " + hh + timeSeprator + mm + timeSeprator + ss;
    return timeFormat;
  }
}

/**
 *
 * 按指定格式生成时间
 * time:时间戳
 * return  yyyy-MM-dd HH-dd-ss格式
 */
export function dateNow(time) {
  if (time) {
    return moment(time).format('YYYY-MM-DD HH:mm:ss');
  }
  return moment().format('YYYY-MM-DD HH:mm:ss');
}

export function shotDateNow(time) {
  if (time) {
    return moment(time).format('YYYY-MM-DD');
  }
  return moment().format('YYYY-MM-DD');
}
/*
* 
* @param {*}  获取据当前多少天的日期
* time：天数
*/
export function getPastDate(time) {
  let today = Date.now();
  return moment(today - parseInt(time) * 24 * 60 * 60 * 1000).format("YYYY-MM-DD");
}
/**
* 
* @param {*}  获取据当前多少天的时间
* time：天数
*/
export function getPastDateTime(time) {
  let today = Date.now();
  return moment(today - parseInt(time) * 24 * 60 * 60 * 1000).format("YYYY-MM-DD HH:mm:ss");
}
export default {
  dateNow,
  shotDateNow,
  getPastDate,
  getPastDateTime
}

